import { render, staticRenderFns } from "./veStuPunishTypeEdit.vue?vue&type=template&id=aab12536&scoped=true"
import script from "./veStuPunishTypeEdit.vue?vue&type=script&lang=js"
export * from "./veStuPunishTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab12536",
  null
  
)

export default component.exports